/**
 * Guided tour for the Interactive Viewer's "In Progress" tab.
 *
 * Importing this module registers the tour as a side effect — import it
 * once anywhere in the bundle (we do it from ``InteractiveViewerPage``)
 * and the registration is permanent for the lifetime of the app.
 *
 * The step list lives in ``../interactive-viewer/steps.ts`` because the
 * Asbuilds tour shares it verbatim. The two tours only differ in the
 * welcome step's copy and the feature-flag they hang off of.
 */
import { registerTour } from '@/features/tours';
import { buildInteractiveViewerSteps } from '@/features/tours/interactive-viewer/steps';
import { FEATURE_FLAGS } from '@/features/featureFlags';

export const IN_PROGRESS_TOUR_ID = 'in_progress.intro';

registerTour({
  id: IN_PROGRESS_TOUR_ID,
  name: 'In Progress',
  // Bump on every meaningful content/structure change so users who saw
  // the old tour see the new one. Keyed by ``${id}@${version}`` server-
  // side too (see ``backend/users/models.py::UserTourState``).
  // v11: added unit-polygon + heat-map steps (area-tag layouts).
  // v12: heat map is now opt-in (off by default); button "turns it on".
  version: 12,
  featureFlagKey: FEATURE_FLAGS.IN_PROGRESS_VIEWER.id,
  steps: buildInteractiveViewerSteps({
    featureName: 'In Progress',
    welcomeBody:
      'This is the In Progress feature, where you can view site photos ' +
      'as various dates during construction.',
  }),
});
